import Flatpickr from 'stimulus-flatpickr'
import 'flatpickr/dist/themes/dark.css'

export default class extends Flatpickr {}
